var _ParserTokensRegistry_tokens;
import { __classPrivateFieldGet } from "tslib";
import { MarkdownParser } from './markdown/MarkdownParser';
export class ParserTokensRegistry {
    constructor() {
        _ParserTokensRegistry_tokens.set(this, {});
    }
    addToken(name, token) {
        __classPrivateFieldGet(this, _ParserTokensRegistry_tokens, "f")[name] = token;
        return this;
    }
    createParser(schema, tokenizer) {
        return new MarkdownParser(schema, tokenizer, __classPrivateFieldGet(this, _ParserTokensRegistry_tokens, "f"));
    }
}
_ParserTokensRegistry_tokens = new WeakMap();
